// extracted by mini-css-extract-plugin
module.exports = {"selected-btn":"index-module_selected-btn_2q_F_"};